<template>
	<div class="card">
		<div class="card-body">
			<b-row v-if="titulosCurso.totalCursos >= 0">
				<b-col>
					<div class="text-center cursorP" @click="loadCursosInTable('disponibles')">
						<h3>
							<i class="fas fa-list-alt" id="iconoTitulo"></i>
							{{ titulosCurso.largoActualDisponibles }}
						</h3>
						<h5 class="header-title" id="titulosCurso" :style=" currentSelector == 'disponibles' ? 'text-decoration:underline;' : 'text-decoration:none;' ">
							Cursos Disponibles
						</h5>
					</div>
				</b-col>
				<b-col>
					<div class="text-center cursorP" @click="loadCursosInTable('archivados')">
						<h3>
							<i class="fas fa-list-alt" id="iconoTitulo"></i>
							{{ titulosCurso.largoActualArchivados }}
						</h3>
						<h5 class="header-title" id="titulosCurso" :style=" currentSelector == 'archivados' ? 'text-decoration:underline;' : 'text-decoration:none;' ">
							Cursos Archivados
						</h5>
					</div>
				</b-col>
				<b-col>
					<div class="text-center">
						<h3>
							<i class="fas fa-layer-group" id="iconoTitulo"></i>
							{{ titulosCurso.totalCampus }}
						</h3>
						<h5 class="header-title" id="titulosCurso">
							Campus Disponibles
						</h5>
					</div>
				</b-col>
				<b-col>
					<div class="text-center">
						<h3>
							<i class="fas fa-users" id="iconoTitulo"></i>
							{{ titulosCurso.totalAlumnos }}
						</h3>
						<h5 class="header-title" id="titulosCurso">
							Usuarios Totales
						</h5>
					</div>
				</b-col>
			</b-row>
			<PuSkeleton v-else :count="3" />
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			titulosTabla:{totalAlumnos:null,totalCursos:null,totalChats:null,totalEncuesta:null, totalCampus:null},
			loadUltimosCursos:false,
			saludo:''
		};
	},
	computed:{
		...mapState("curso", ["jsonCurso"]),
		...mapState('curso',['titulosCurso']),
		...mapState("curso", ["currentSelector"]),
	},
	methods:{
		...mapActions("curso", ["updateOnlyCurso"]),
		...mapActions("curso", ["setCurrentSelector"]),
		loadCursosInTable(type){
			if(type == 'archivados'){
				this.setCurrentSelector("archivados");
				this.updateOnlyCurso(this.titulosCurso.cursosArchivados);
			}else{
				this.setCurrentSelector("disponibles");
				this.updateOnlyCurso(this.titulosCurso.cursosDisponibles);
			}
		}
	}
};
</script>
<style scoped>
#titulosCurso {
	color: #F3931A;
	text-transform: uppercase;
	font-weight: 900;
	text-rendering: optimizeLegibility;
}
#iconoTitulo {
	color: #03a9f4;
}
.cursorP{
	cursor: pointer;
}
</style>